import type { JSX } from 'react';
import { LuBot, LuBotOff, LuCalendarClock, LuFileText, LuListTodo, LuVideo } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import type { EventDetailsActionProps } from './useEventDetailsModel';

export function EventDetailsDrawerActions({
    canInviteMeetingBot,
    canInviteMeetingBotDisabledReason,
    canScheduleMeetingBot,
    canJoinMeeting,
    canStopMeetingBot,
    canUnscheduleMeetingBot,
    eventUrl,
    onCreateNote,
    onCreateTask,
    onInviteMeetingBot,
    onScheduleMeetingBot,
    onRemoveMeetingBot,
}: EventDetailsActionProps): JSX.Element {
    return (
        <div className="space-y-3 border-t pt-4">
            {canJoinMeeting && eventUrl ? (
                <Button variant="outline" className="w-full justify-start" asChild>
                    <a href={eventUrl} target="_blank" rel="noopener noreferrer">
                        <LuVideo className="mr-2 h-4 w-4" />
                        Join Meeting
                    </a>
                </Button>
            ) : null}
            {canInviteMeetingBot ? (
                <Button variant="outline" className="w-full cursor-pointer justify-start" onClick={onInviteMeetingBot}>
                    <LuBot className="mr-2 h-4 w-4" />
                    Invite Claire&#8482;
                </Button>
            ) : canInviteMeetingBotDisabledReason ? (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span className="flex w-full">
                                <Button
                                    variant="outline"
                                    className="w-full cursor-not-allowed justify-start opacity-50"
                                    disabled
                                >
                                    <LuBot className="mr-2 h-4 w-4" />
                                    Invite Claire&#8482;
                                </Button>
                            </span>
                        </TooltipTrigger>
                        <TooltipContent side="top" className="max-w-64">
                            {canInviteMeetingBotDisabledReason}
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            ) : null}
            {canScheduleMeetingBot ? (
                <Button
                    variant="outline"
                    className="w-full cursor-pointer justify-start"
                    onClick={onScheduleMeetingBot}
                >
                    <LuCalendarClock className="mr-2 h-4 w-4" />
                    Schedule Claire&#8482;
                </Button>
            ) : null}
            {canStopMeetingBot ? (
                <Button variant="outline" className="w-full cursor-pointer justify-start" onClick={onRemoveMeetingBot}>
                    <LuBotOff className="mr-2 h-4 w-4" />
                    Stop Recording
                </Button>
            ) : null}
            {canUnscheduleMeetingBot ? (
                <Button variant="outline" className="w-full cursor-pointer justify-start" onClick={onRemoveMeetingBot}>
                    <LuBotOff className="mr-2 h-4 w-4" />
                    Unschedule Meeting Bot
                </Button>
            ) : null}
            <Button variant="outline" className="w-full cursor-pointer justify-start" onClick={onCreateNote}>
                <LuFileText className="mr-2 h-4 w-4" />
                Create Note
            </Button>
            <Button variant="outline" className="w-full cursor-pointer justify-start" onClick={onCreateTask}>
                <LuListTodo className="mr-2 h-4 w-4" />
                Create Task
            </Button>
        </div>
    );
}
